module.exports = __webpack_public_path__ + "static/top-left-hexagons-7404ca5568c8f57b0fcb2fb60a1689fd.png";